import { API, axiosInstance } from "lib";

export const getPodFollowupList = (data = {}) => {
  return axiosInstance
    .post(API.GET_POD_FOLLOWUP, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};